import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  setPersona,
  openMainModal,
  getSkills,
  sendSkills,
  getUserSkill,
  addSkill,
  removeSkill
} from "../../store/actions/index";
import { fireAnalytics } from "../../utils/firebase";
import Lottie from "react-lottie";
import successData from "../../assets/lotties/success.json";
import FileUpload from "../FileUpload/FileUpload";
import Button from "../UI/Forms/Button/Button";
import Input from "../UI/Forms/Input/Input";
import styles from "./FormularioPersona.module.scss";
import BotonSkills from "../../components/UI/BotonSkills/BotonSkills";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrowDownIcon.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/svg/arrowUpIcon.svg";

const FormularioPersona = ({
  name,
  lastName,
  dniCuil,
  profession,
  getSkills,
  sendSkills,
  getUserSkill,
  addSkill,
  removeSkill,
  skills,
  userSkills,
  skillContent,
  tel,
  address,
  webSite,
  file,
  setPersona,
  skillList,
  history,
}) => {
  const [showSkillSelector, setShowSkillSelector] = useState(false);
  useEffect(() => {
    fireAnalytics("ob_step_2", { category: "navigation" });
    getSkills();
  }, []);

  let skillsDisponibles = null;
  let skillSelected = false;

  if (skills) {
    skillsDisponibles = skills.map((skill) => {
      if (userSkills) {
        skillSelected = false;
        userSkills.forEach((userSkill) => {
          if (userSkill.id === skill.id) {
            skillSelected = true;
          }
        });
      }
      return (
        <BotonSkills skillSelected={skillSelected} key={skill.id} id={skill.id}>
          {skill.name}
        </BotonSkills>
      );
    });
  }

  const toggleSkillSelector = () => {
    setShowSkillSelector((prevState) => !prevState);
  };

  const defaultOptions = {
    loop: false,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const webSiteRegex = /(^[a-zA-Z_-]{3})([.]{1})([a-zA-Z0-9_.+-]+)([.]{1})([a-zA-Z_-]+)/;
  const telRegex = /[0-9+]/;
  const companySchema = Yup.object().shape({
    name: Yup.string().required("El campo es requerido."),
    lastName: Yup.string().required("El campo es requerido."),
    tel: Yup.string()
      .matches(telRegex, "Introduzca un formato válido")
      .min(7, "Ingrese un telefono válido")
      .max(13, "Ingrese un telefono válido"),
    address: Yup.string(),
    webSite: Yup.string().matches(webSiteRegex, "Introduzca un formato válido"),
  });

  const FormGroup = styled.div`
    margin: 15px 0;
    position: relative;
    width: 100%;
  `;

  const ButtonContainer = styled.div`
    display: flex;
    a {
      margin-right: 10px;
    }
  `;

  const handleSpecialKey = (event) => {
    const filter = /^[a-zA-Z ]*$/;
    if (!filter.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          name,
          lastName,
          field: "",
          tel,
          address,
          webSite,
        }}
        validationSchema={companySchema}
        onSubmit={(values) => {
          setPersona(values, file, history);
        }}
      >

        {({ handleSubmit, isValid, touched, values, errors }) => (
          <>
            <Form
              className={styles.formContainer}
              onSubmit={handleSubmit}
            >
              <FileUpload userType="person" file={file} name="file" />
              <div className={styles.inputRow}>
                <FormGroup>
                  <Field
                    handleKey={handleSpecialKey}
                    placeholder="Nombre*"
                    type="text"
                    name="name"
                    component={Input}
                    className={`${touched.name && values.name === "" && errors.name ? "error" : ""}${values.name !== "" && !errors.name ? "isValid" : ""
                      }`}
                    style={
                      values.name !== ""
                        ? {
                          textOverflow: "ellipsis",
                          paddingRight: "5rem",
                          display: "block",
                        }
                        : null
                    }
                  />
                  {values.name !== "" && !errors.name ? (
                    <Lottie
                      options={{
                        animationData: successData,
                        ...defaultOptions,
                      }}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                      height={35}
                      width={35}
                    />
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <Field
                    handleKey={handleSpecialKey}
                    placeholder="Apellido*"
                    type="text"
                    name="lastName"
                    component={Input}
                    className={`${touched.lastName && values.lastName === "" && errors.lastName ? "error" : ""}${values.lastName !== "" && !errors.lastName ? "isValid" : ""
                      }`}
                    style={
                      values.lastName !== ""
                        ? {
                          textOverflow: "ellipsis",
                          paddingRight: "5rem",
                          display: "block",
                        }
                        : null
                    }
                  />
                  {values.lastName !== "" && !errors.lastName ? (
                    <Lottie
                      options={{
                        animationData: successData,
                        ...defaultOptions,
                      }}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                      height={35}
                      width={35}
                    />
                  ) : null}
                </FormGroup>
              </div>
              <div className={styles.inputRow}>
                <FormGroup>
                  <Field
                    placeholder="Dirección profesional"
                    type="text"
                    name="address"
                    component={Input}
                    style={
                      values.address !== ""
                        ? {
                          textOverflow: "ellipsis",
                          paddingRight: "5rem",
                          display: "block",
                        }
                        : null
                    }
                    className={`${touched.address && values.address === "" && errors.address ? "error" : ""}${values.address !== "" && !errors.address ? "isValid" : ""
                      }`}
                  />
                  {values.address !== "" && !errors.address ? (
                    <Lottie
                      options={{
                        animationData: successData,
                        ...defaultOptions,
                      }}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                      height={35}
                      width={35}
                    />
                  ) : null}
                </FormGroup>
                <FormGroup>
                  <Field
                    placeholder="Teléfono"
                    type="number"
                    name="tel"
                    component={Input}
                    className={`${touched.tel && values.tel === "" && errors.tel ? styles.error : ""}${values.tel !== "" && !errors.tel ? "isValid" : ""
                      }`}
                    style={
                      values.tel !== ""
                        ? {
                          textOverflow: "ellipsis",
                          paddingRight: "5rem",
                          display: "block",
                        }
                        : null
                    }
                  />
                  {values.tel !== "" && !errors.tel ? (
                    <Lottie
                      options={{
                        animationData: successData,
                        ...defaultOptions,
                      }}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                      }}
                      height={35}
                      width={35}
                    />
                  ) : null}
                </FormGroup>
              </div>
              <FormGroup>
                <div className={styles.skillsContainer}>
                  <div className={styles.skillsContainer_dropDown} >
                    {userSkills?.length > 0 && <div className={`${styles.skillsContainer_selected}  ${userSkills?.length > 0 ? styles.skillSelected : ""}`} >
                      {userSkills.map((skill) => {
                        return <div className={styles.skillsContainer_skillSelected} key={skill.id} onClick={() => removeSkill(skill.id)}>{skill.name}</div>
                      })}
                    </div>}
                    {userSkills?.length === 0 && <div className={styles.skillsContainer_selected} >Seleccioná al menos 1 rubro*</div>}
                    <div className={styles.skillsContainer_arrow} onClick={toggleSkillSelector}>
                      {showSkillSelector ? <ArrowUpIcon width={20} height={20} /> : <ArrowDownIcon width={20} height={20} />}
                      {userSkills?.length > 0 &&
                        <Lottie
                          options={{
                            animationData: successData,
                            ...defaultOptions,
                          }}
                          style={{
                            position: "absolute",
                            top: "22px",
                            right: "40px",
                            transform: "translateY(-50%)",
                          }}
                          height={35}
                          width={35}
                        />}
                    </div>
                  </div>
                  {showSkillSelector && (
                    <div className={styles.selectTypeContainer_container}>
                      <div className={styles.selectTypeContainer}>
                        <div className={styles.typeContainer}>
                          <div className={styles.skillContainer}>{skillsDisponibles}</div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </FormGroup>
              <FormGroup>
                <Field
                  placeholder="Página Web: www.example.com"
                  type="text"
                  name="webSite"
                  component={Input}
                  className={`${touched.webSite && errors.webSite ? "error" : ""}${values.webSite !== "" && !errors.webSite ? "isValid" : ""
                    }`}
                />
                {values.webSite !== "" && !errors.webSite ? (
                  <Lottie
                    options={{
                      animationData: successData,
                      ...defaultOptions,
                    }}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                    }}
                    height={35}
                    width={35}
                  />
                ) : null}
              </FormGroup>
              <ButtonContainer>
                <Button
                  colored="white"
                  typeBtn="link"
                  to="select-type"
                  onClick={() =>
                    fireAnalytics("ob_step_2_back", { category: "navigation" })
                  }
                >
                  Volver
                </Button>
                <button
                  className={styles.btn}
                  disabled={!isValid || values.name === "" || userSkills?.length === 0}
                  type="submit"
                  onClick={() => {
                    fireAnalytics("ob_step_2_profesional", {
                      category: "onboarding",
                    });
                    sendSkills(userSkills, history)
                  }
                  }
                >
                  Siguiente
                </button>
              </ButtonContainer>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    name: state.register.personaForm.name,
    lastName: state.register.personaForm.lastName,
    dniCuil: state.register.personaForm.dniCuil,
    profession: state.register.personaForm.profession,
    tel: state.register.personaForm.tel,
    address: state.register.personaForm.address,
    webSite: state.register.personaForm.webSite,
    file: state.register.file,
    skills: state.register.skills,
    userSkills: state.register.userSkills,
    skillContent: state.register.skillContent,
  };
};

export default connect(mapStateToProps, {
  setPersona, openMainModal, getSkills, sendSkills,
  getUserSkill,
  addSkill,
  removeSkill
})(
  FormularioPersona
);

